import logo from 'assets/images/logo-chart.png'

async function exportCanvasAsPng (canvas, filename, title) {
  // duplicate canvas and add margin for title and copyright
  const newCanvas = document.createElement('canvas')
  const context = newCanvas.getContext('2d')
  newCanvas.width = canvas.width
  newCanvas.height = canvas.height + 80
  context.drawImage(canvas, 0, 40)
  // add title
  context.fillStyle = '#00758f'
  context.font = 'bold 18px Arial'
  context.textAlign = 'center'
  context.fillText(title, newCanvas.width / 2, 25)
  // add copyright text
  context.fillStyle = '#666'
  context.font = '12px Arial'
  context.textAlign = 'center'
  const copyrightText = 'Copyright ©Enerdata www.enerdata.net 2009-' + new Date().getFullYear() + ' - All rights reserved'
  context.fillText(copyrightText, newCanvas.width / 2, newCanvas.height - 25)
  // add logo image
  const logoObj = await loadImage(logo)
  context.drawImage(logoObj, 40, newCanvas.height - logoObj.height)
  context.globalCompositeOperation = 'destination-over'
  context.fillStyle = 'white'
  context.fillRect(0, 0, newCanvas.width, newCanvas.height)
  // export image
  const link = document.createElement('a')
  link.download = filename
  link.href = newCanvas.toDataURL('image/png', 1.0)
  link.click()
  newCanvas.remove()
}

function loadImage (src) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}

export { exportCanvasAsPng }
